export var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["INVALID_NUMBER"] = "invalid_number";
    ErrorMessage["INVALID_SNAKE_CASE"] = "invalid_snake_case";
    ErrorMessage["INVALID_PASCAL_CASE"] = "invalid_pascal_case";
    ErrorMessage["INVALID_ACTION"] = "invalid_action";
    ErrorMessage["INVALID_PRODUCT"] = "invalid_product";
    ErrorMessage["DATA_LAYER_TRACKER_UNAVAILABLE"] = "data_layer_tracker_unavailable";
})(ErrorMessage || (ErrorMessage = {}));
